
export const RESOURCES_REQUEST_LOADING: string = 'resources/REQUEST_LOADING';
export const RESOURCES_REQUEST_START: string = 'resources/REQUEST_START';
export const RESOURCES_REQUEST_FAIL: string = 'resources/REQUEST_FAIL';
export const RESOURCES_REQUEST_SUCCESS: string = 'resources/REQUEST_SUCCESS';
